import { render, staticRenderFns } from "./NameCard.vue?vue&type=template&id=1bba32d6&scoped=true"
import script from "./NameCard.vue?vue&type=script&lang=js"
export * from "./NameCard.vue?vue&type=script&lang=js"
import style0 from "./NameCard.vue?vue&type=style&index=0&id=1bba32d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bba32d6",
  null
  
)

export default component.exports